{
  "familyId": "TAA-SOORT-BW",
  "questions": [
    {
      "id": "TAA-SOORT-BW-001",
      "familyId": "TAA-SOORT-BW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_bijwoord",
      "questionType": "multiple_choice",
      "question": "Welk woord is een bijwoord in de zin: 'De kat loopt langzaam naar de deur.'?",
      "options": ["langzaam", "kat", "loopt", "deur"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Bijwoord herkennen",
            "content": "Een bijwoord zegt iets over het werkwoord (hoe, wanneer, waar). Vraag: Hoe loopt de kat? → langzaam. 'Langzaam' is een bijwoord: het zegt HOE de kat loopt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bijwoord_herkennen",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.noun-as-adverb", "label": "Verwart zelfstandig naamwoord met bijwoord", "optionIndex": 1 },
          { "id": "taa.verb-as-adverb", "label": "Verwart werkwoord met bijwoord", "optionIndex": 2 },
          { "id": "taa.noun-as-adverb", "label": "Verwart zelfstandig naamwoord met bijwoord", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "'Langzaam' is een bijwoord. Het zegt iets over het werkwoord 'loopt': HOE loopt de kat? Langzaam. Een bijwoord geeft extra informatie over een werkwoord.",
        "solutionSteps": [
          "Vraag: Hoe loopt de kat?",
          "Antwoord: langzaam",
          "'Langzaam' zegt iets over het werkwoord → bijwoord"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Langzaam' is een bijwoord dat zegt HOE de kat loopt.",
          "1": "'Kat' is een zelfstandig naamwoord (je kunt er 'de' of 'het' voor zetten).",
          "2": "'Loopt' is een werkwoord (het zegt wat de kat doet).",
          "3": "'Deur' is een zelfstandig naamwoord."
        }
      }
    },
    {
      "id": "TAA-SOORT-BW-002",
      "familyId": "TAA-SOORT-BW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_bijwoord",
      "questionType": "multiple_choice",
      "question": "Wat is het verschil tussen een bijvoeglijk naamwoord en een bijwoord?",
      "options": [
        "Een BNW zegt iets over een zelfstandig naamwoord, een bijwoord over een werkwoord",
        "Een BNW staat altijd voor het werkwoord, een bijwoord erna",
        "Er is geen verschil, het zijn dezelfde woordsoort",
        "Een bijwoord staat altijd aan het begin van de zin"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BNW vs bijwoord",
            "content": "BNW = zegt iets over een zelfstandig naamwoord (de SNELLE auto). Bijwoord = zegt iets over een werkwoord (hij rijdt SNEL). Zelfde woord, andere functie!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bijwoord_vs_bnw",
      "variantIndex": 2,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.68,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.adverb-position-rule", "label": "Denkt dat positie in zin het verschil bepaalt", "optionIndex": 1 },
          { "id": "taa.adverb-bnw-same", "label": "Denkt dat bijwoord en BNW dezelfde woordsoort zijn", "optionIndex": 2 },
          { "id": "taa.adverb-always-first", "label": "Denkt dat bijwoord altijd aan begin van zin staat", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Een bijvoeglijk naamwoord (BNW) zegt iets over een zelfstandig naamwoord: 'de snelle auto'. Een bijwoord zegt iets over een werkwoord: 'hij rijdt snel'. Let op: soms is het dezelfde woordvorm, maar de functie verschilt!",
        "solutionSteps": [
          "BNW → zegt iets over een zelfstandig naamwoord (de SNELLE auto)",
          "Bijwoord → zegt iets over een werkwoord (hij rijdt SNEL)",
          "Zelfde woord kan beide zijn, afhankelijk van de zin"
        ],
        "distractorExplanations": {
          "0": "Goed! BNW hoort bij een zelfstandig naamwoord, bijwoord bij een werkwoord.",
          "1": "De positie in de zin bepaalt niet of iets een BNW of bijwoord is. Het gaat om de functie: bij welk woord hoort het?",
          "2": "Het zijn wél twee verschillende woordsoorten met verschillende functies.",
          "3": "Een bijwoord kan overal in de zin staan, niet alleen aan het begin."
        }
      }
    },
    {
      "id": "TAA-SOORT-BW-003",
      "familyId": "TAA-SOORT-BW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_bijwoord",
      "questionType": "multiple_choice",
      "question": "In welke zin is 'hard' een bijwoord?",
      "options": [
        "Hij werkt hard.",
        "Het is een harde wind.",
        "De harde steen viel op de grond.",
        "Dat is een hard geluid."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Bijwoord of BNW?",
            "content": "Stel de vraag: hoort het woord bij een werkwoord of bij een zelfstandig naamwoord? 'Hij werkt hard' → hard hoort bij 'werkt' (werkwoord) → bijwoord. 'Harde wind' → hard hoort bij 'wind' (znw) → BNW.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bijwoord_functie",
      "variantIndex": 3,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.67,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.bnw-as-adverb", "label": "Verwart BNW bij znw met bijwoord", "optionIndex": 1 },
          { "id": "taa.bnw-as-adverb", "label": "Verwart BNW bij znw met bijwoord", "optionIndex": 2 },
          { "id": "taa.bnw-as-adverb", "label": "Verwart BNW bij znw met bijwoord", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "In 'Hij werkt hard' hoort 'hard' bij het werkwoord 'werkt' (HOE werkt hij? Hard). Dus is het een bijwoord. In de andere zinnen hoort 'hard(e)' bij een zelfstandig naamwoord (wind, steen, geluid) → dan is het een BNW.",
        "solutionSteps": [
          "'Hij werkt hard' → hard hoort bij 'werkt' (werkwoord)",
          "Vraag: HOE werkt hij? → hard",
          "Hard = bijwoord (zegt iets over het werkwoord)"
        ],
        "distractorExplanations": {
          "0": "Goed! In 'Hij werkt hard' is 'hard' een bijwoord (het zegt HOE hij werkt).",
          "1": "'Harde wind' → 'harde' hoort bij 'wind' (zelfstandig naamwoord) → bijvoeglijk naamwoord.",
          "2": "'Harde steen' → 'harde' hoort bij 'steen' (zelfstandig naamwoord) → bijvoeglijk naamwoord.",
          "3": "'Hard geluid' → 'hard' hoort bij 'geluid' (zelfstandig naamwoord) → bijvoeglijk naamwoord."
        }
      }
    },
    {
      "id": "TAA-SOORT-BW-004",
      "familyId": "TAA-SOORT-BW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_bijwoord",
      "questionType": "multiple_choice",
      "question": "Welk bijwoord geeft een TIJD aan?",
      "options": ["gisteren", "buiten", "langzaam", "graag"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Soorten bijwoorden",
            "content": "Bijwoorden geven aan: HOE (langzaam, snel), WANNEER (gisteren, morgen, nu), WAAR (buiten, hier, daar), of MATE (heel, erg, graag). 'Gisteren' geeft een TIJD aan.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bijwoord_soorten",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.adverb-place-as-time", "label": "Verwart bijwoord van plaats met tijd", "optionIndex": 1 },
          { "id": "taa.adverb-manner-as-time", "label": "Verwart bijwoord van wijze met tijd", "optionIndex": 2 },
          { "id": "taa.adverb-degree-as-time", "label": "Verwart bijwoord van mate met tijd", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "'Gisteren' is een bijwoord van tijd (WANNEER?). 'Buiten' is een bijwoord van plaats (WAAR?). 'Langzaam' is een bijwoord van wijze (HOE?). 'Graag' is een bijwoord van mate.",
        "solutionSteps": [
          "Gisteren → WANNEER? → bijwoord van tijd ✓",
          "Buiten → WAAR? → bijwoord van plaats",
          "Langzaam → HOE? → bijwoord van wijze",
          "Graag → HOE GRAAG? → bijwoord van mate"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Gisteren' is een bijwoord van tijd (het geeft aan WANNEER iets gebeurt).",
          "1": "'Buiten' geeft een PLAATS aan (WAAR?), niet een tijd.",
          "2": "'Langzaam' geeft een WIJZE aan (HOE?), niet een tijd.",
          "3": "'Graag' geeft een MATE aan, niet een tijd."
        }
      }
    },
    {
      "id": "TAA-SOORT-BW-005",
      "familyId": "TAA-SOORT-BW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_bijwoord",
      "questionType": "matching",
      "question": "Koppel elk bijwoord aan het juiste soort.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "snel", "right": "Wijze (HOE?)" },
          { "left": "morgen", "right": "Tijd (WANNEER?)" },
          { "left": "hier", "right": "Plaats (WAAR?)" },
          { "left": "heel", "right": "Mate (HOEVEEL?)" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Soorten bijwoorden",
            "content": "Bijwoorden beantwoorden vragen: HOE? (wijze), WANNEER? (tijd), WAAR? (plaats), HOEVEEL/HOE ERG? (mate). Stel de vraag en je weet het soort.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bijwoord_soorten_match",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.69,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Snel → HOE? (wijze), morgen → WANNEER? (tijd), hier → WAAR? (plaats), heel → HOEVEEL? (mate). Stel altijd de vraag om het soort bijwoord te bepalen.",
        "solutionSteps": [
          "Snel → HOE doet hij het? → wijze",
          "Morgen → WANNEER? → tijd",
          "Hier → WAAR? → plaats",
          "Heel → HOE ERG? → mate"
        ]
      }
    },
    {
      "id": "TAA-SOORT-BW-006",
      "familyId": "TAA-SOORT-BW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_bijwoord",
      "questionType": "categorize",
      "question": "Sorteer de woorden: is het een bijwoord of een bijvoeglijk naamwoord?",
      "data": {
        "categories": ["Bijwoord", "Bijvoeglijk naamwoord"],
        "items": [
          { "text": "snel (hij loopt snel)", "correctCategory": 0 },
          { "text": "mooie", "correctCategory": 1 },
          { "text": "vaak", "correctCategory": 0 },
          { "text": "grote", "correctCategory": 1 },
          { "text": "altijd", "correctCategory": 0 },
          { "text": "rode", "correctCategory": 1 },
          { "text": "graag", "correctCategory": 0 },
          { "text": "kleine", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Bijwoord vs. bijvoeglijk naamwoord",
            "content": "Een bijwoord zegt iets over een werkwoord: HOE, WANNEER, HOE VAAK (snel, vaak, altijd, graag). Een bijvoeglijk naamwoord zegt iets over een zelfstandig naamwoord en krijgt vaak -e: de mooie bloem, het grote huis.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bijwoord_vs_bnw_categoriseer",
      "variantIndex": 6,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Bijwoorden (snel, vaak, altijd, graag) zeggen iets over een werkwoord: hoe, wanneer, hoe vaak. Bijvoeglijke naamwoorden (mooie, grote, rode, kleine) zeggen iets over een zelfstandig naamwoord en krijgen vaak -e.",
        "solutionSteps": [
          "Test: zegt het woord iets over een werkwoord? → bijwoord",
          "Test: zegt het woord iets over een zelfstandig naamwoord? → bijvoeglijk naamwoord",
          "Bijwoorden: snel, vaak, altijd, graag",
          "Bijvoeglijke naamwoorden: mooie, grote, rode, kleine"
        ]
      }
    },
    {
      "id": "TAA-SOORT-BW-007",
      "familyId": "TAA-SOORT-BW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_bijwoord",
      "questionType": "categorize",
      "question": "Sorteer de bijwoorden: geven ze aan HOE, WANNEER of HOE VAAK iets gebeurt?",
      "data": {
        "categories": ["Hoe (wijze)", "Wanneer (tijd)", "Hoe vaak (frequentie)"],
        "items": [
          { "text": "snel", "correctCategory": 0 },
          { "text": "gisteren", "correctCategory": 1 },
          { "text": "vaak", "correctCategory": 2 },
          { "text": "voorzichtig", "correctCategory": 0 },
          { "text": "morgen", "correctCategory": 1 },
          { "text": "nooit", "correctCategory": 2 },
          { "text": "hard", "correctCategory": 0 },
          { "text": "soms", "correctCategory": 2 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Soorten bijwoorden",
            "content": "Bijwoorden van wijze (hoe?): snel, voorzichtig, hard. Bijwoorden van tijd (wanneer?): gisteren, morgen, nu. Bijwoorden van frequentie (hoe vaak?): vaak, nooit, soms, altijd.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bijwoord_categoriseer_type",
      "variantIndex": 7,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Bijwoorden van wijze (hoe?): snel, voorzichtig, hard. Bijwoorden van tijd (wanneer?): gisteren, morgen. Bijwoorden van frequentie (hoe vaak?): vaak, nooit, soms.",
        "solutionSteps": [
          "Vraag bij elk bijwoord: beantwoordt het HOE, WANNEER of HOE VAAK?",
          "Hoe → snel, voorzichtig, hard",
          "Wanneer → gisteren, morgen",
          "Hoe vaak → vaak, nooit, soms"
        ]
      }
    },
    {
      "id": "TAA-SOORT-BW-008",
      "familyId": "TAA-SOORT-BW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_bijwoord",
      "questionType": "true_false_series",
      "question": "Beoordeel elke bewering over bijwoorden.",
      "data": {
        "statements": [
          { "text": "Een bijwoord zegt iets over een werkwoord.", "isTrue": true },
          { "text": "'Mooie' in 'de mooie bloem' is een bijwoord.", "isTrue": false },
          { "text": "'Gisteren' is een bijwoord van tijd.", "isTrue": true },
          { "text": "Een bijwoord en een bijvoeglijk naamwoord zijn hetzelfde.", "isTrue": false }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Bijwoorden controleren", "content": "Een bijwoord zegt iets over een werkwoord (hoe, wanneer, waar). Een bijvoeglijk naamwoord zegt iets over een zelfstandig naamwoord. 'Mooie bloem' → BNW. 'Gisteren' → wanneer? → bijwoord van tijd.", "icon": "lightbulb" } }
      ],
      "conceptId": "bijwoord_waar_onwaar",
      "variantIndex": 8,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.71,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Een bijwoord zegt inderdaad iets over een werkwoord (hoe, wanneer, waar). 'Mooie' hoort bij 'bloem' (znw) → BNW, geen bijwoord. 'Gisteren' beantwoordt de vraag 'wanneer?' → bijwoord van tijd. BNW en bijwoord zijn twee verschillende woordsoorten.",
        "solutionSteps": [
          "Bijwoord → zegt iets over werkwoord ✓ (waar)",
          "'Mooie bloem' → hoort bij znw → BNW, niet bijwoord (onwaar)",
          "'Gisteren' → wanneer? → bijwoord van tijd ✓ (waar)",
          "BNW ≠ bijwoord → verschillende woordsoorten (onwaar)"
        ]
      }
    }
  ]
}